<template>
  <div class="schedule">
    <div class="schedule__item" v-for="(schedule, index) in schedules" :key="index" :class="getDayClass(index)">
      <p class="schedule__time">{{ formatTime(schedule.start, schedule.finish) }}</p>
      <p class="schedule__day">{{ formatDay(schedule.start) }}</p>
      <p class="schedule__month">{{ formatMonth(schedule.start) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    schedules: {
      type: Array,
      required: true,
    },
    scheduleIndex: {
      type: Number,
      default: -1, // Значение по умолчанию
    },
    run: {
      type: Boolean,
      default: false,
    }
  },

  methods: {
    formatTime(start, finish) {
      const startDate = new Date(start);
      const finishDate = new Date(finish);
      const userTimezoneOffset = startDate.getTimezoneOffset() / 60 * -1;

      startDate.setHours(startDate.getHours() + 4);
      finishDate.setHours(finishDate.getHours() + 4);

      const startTime = startDate.toTimeString().slice(0, 5);
      const finishTime = finishDate.toTimeString().slice(0, 5);

      return `${startTime} - ${finishTime}`;
    },
    formatDay(date) {
      return new Date(date).getDate().toString().padStart(2, '0');
    },
    formatMonth(date) {
      const monthNames = [
        "январь", "февраль", "март", "апрель", "май", "июнь",
        "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"
      ];
      return monthNames[new Date(date).getMonth()];
    },
    getDayClass(index) {
      // Определяем классы на основе текущего индекса и состояния run
      if (index < this.scheduleIndex) {
        return 'past';
      } else if (index === this.scheduleIndex) {
        return this.run ? 'run' : 'today';
      }
      return '';
    }
  }
};
</script>